export default {
  solutions: [],
  solution: undefined,
  summary: undefined,
};
